import Section from 'src/components/sections/Section'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Lazy } from 'swiper'
import { Link } from 'gatsby'
import './sectionBrand.scss'

const SectionBrand = (dataCMS: any, slidesPerView: number) => {
  const dataBrand = dataCMS.data.sections[0].data.items

  const branchPictos = dataBrand.sectionC.categoriesBrand

  if (!branchPictos?.length) {
    return null
  }

  return (
    <div className="section-info-brand mb-12 flex items-center justify-between layout__content">
      <div className="info-brand md:ml-auto">
        <div className="flex items-center md:ml-[calc((100vw - 1344px) / 2)] md:max-w-[280px]">
          {dataBrand.sectionA.brandLogo !== '' && (
            <img
              className="image-brand"
              alt={`${dataBrand.sectionA.brandSports} - ${dataBrand.sectionA.brandName}`}
              title={`${dataBrand.sectionA.brandSports} - ${dataBrand.sectionA.brandName}`}
              src={dataBrand.sectionA.brandLogo}
            />
          )}

          <div className="data-brand flex flex-col">
            {dataBrand.sectionA.brandName !== '' && (
              <h1 className="brand-name mt-0 mb-0.5">
                {dataBrand.sectionA.brandName}
              </h1>
            )}
            {dataBrand.sectionA.brandSports !== '' && (
              <h2 className="brand-type">{dataBrand.sectionA.brandSports}</h2>
            )}
          </div>
        </div>
      </div>

      <p className="title-categories md:hidden">Navegue por categorias</p>
      <Section className="slick-slide-section pictos-brands layout__content layout__section">
        <ul>
          <Swiper
            className="slick-slide-swiper"
            slidesPerView={3}
            navigation={{
              prevEl: '.arrow-brands-prev',
              nextEl: '.arrow-brands-next',
            }}
            breakpoints={{
              1244: {
                slidesPerView: 7,
                spaceBetween: 16,
              },
              1190: {
                slidesPerView: 7,
                spaceBetween: 16,
              },
              1100: {
                slidesPerView: 7,
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: 7,
                spaceBetween: 16,
              },
              768: {
                slidesPerView: 4.5,
                spaceBetween: 16,
              },
              420: {
                slidesPerView: 3.5,
                spaceBetween: 16,
              },
              375: {
                slidesPerView: 3.5,
                spaceBetween: 16,
              },
              320: {
                slidesPerView: 3.5,
                spaceBetween: 16,
              },
            }}
            lazy={{
              loadPrevNext: true,
              loadPrevNextAmount: slidesPerView,
            }}
            modules={[Navigation, Lazy]}
          >
            <div className="arrow-brands-prev !flex bg-lighestGray" />
            <div className="arrow-brands-next !flex bg-lighestGray" />
            {branchPictos.map((item: any, index: number) => {
              return (
                <SwiperSlide key={index}>
                  <li className="slick-slide-item">
                    <Link
                      to={item.categoryURL}
                      className="slick-slide-item"
                      rel="nofollow"
                    >
                      <div className="content-image">
                        <img
                          alt={item.categoryName}
                          title={item.categoryName}
                          src={item.categoryPicto}
                        />
                      </div>

                      <p className="text-neutral10">{item.categoryName}</p>
                    </Link>
                  </li>
                </SwiperSlide>
              )
            })}
          </Swiper>
        </ul>
      </Section>
    </div>
  )
}

export default SectionBrand
